import request from '../../utils/request';

// 获取群聊列表数据
export function getList(params,authorization,notShowLoading){
  return request({
    url: '/api/qywechat/group_chat/list',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },notShowLoading)
}
// 获取群聊标签数据
export function getTagList(authorization,notShowLoading){
    return request({
      url: '/api/qywechat/group_chat/tag',
      method: 'get',
      headers: {
        "authorization": authorization
      }
    },notShowLoading)
  }
//   新建标签组
export function createGroupTag(authorization, params){
    return request({
      url: `/api/qywechat/group_chat/tag_type?groupName=${params}`,
      method: 'post',
      headers: {
        "authorization": authorization
      }
    })
  }
  //   新增群标签
export function createTag(authorization, params){
    return request({
      url: `/api/qywechat/group_chat/tag?groupId=${params.groupId}&tagName=${params.tagName}`,
      method: 'post',
      headers: {
        "authorization": authorization
      }
    })
  }
//   删除群标签
export function deleteGroupTag(authorization, id){
    return request({
      url: `/api/qywechat/group_chat/tag/${id}`,
      method: 'delete',
      headers: {
        "authorization": authorization
      }
    })
  }
//   查询群标签列表
  export function getGroupTag(authorization){
    return request({
      url: '/api/qywechat/group_chat/tag',
      method: 'get',
      headers: {
        "authorization": authorization
      }
    })
  }
//   删除所打的群聊标签
export function deleteGroupTags(authorization, params,isloading = false){
    return request({
      url: `/api/qywechat/group_chat/tag/del?chatId=${params.chatId}&tagId=${params.tagId}`,
      method: 'delete',
      headers: {
        "authorization": authorization
      }
    }, isloading)
  }
//   群聊打标签
export function addTagItems(authorization, params,isloading = false){
    return request({
      url: '/api/qywechat/group_chat/tag/add',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },isloading)
  }
  

// 查看群聊消息
export function getGroupMsg(params,authorization, isloading = true){
    return request({
      url: '/api/qywechat/group_chat/msg',
      method: 'post',
      data: {
        chatId: params.chatId,
        msgType: params.msgType,
        startTime: params.startTime,
        endTime: params.endTime,
        current: params.current,
        size: params.size
      },
      headers: {
        "authorization": authorization
      }
    },isloading)
  }
  //   删除标签组
export function delTagGroup(params,authorization,isloading = false){
  return request({
    url: `/api/qywechat/group_chat/tagdel?groupId=${params}`,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  },isloading)
}

  //   同步群聊消息
  export function getGroupMessage(authorization,isloading = false){
    return request({
      url: `/api/qywechat/group_chat/syn`,
      method: 'get',
      headers: {
        "authorization": authorization
      }
    },isloading)
  }


/** 获取新版群聊消息 */  
  export function getGroupChatNewMsg(params,authorization,isloading = false){
    return request({
      url: `/api/qywechat/group_chat/newMsg`,
      method: 'post',
      data: {
        chatId: params.chatId,
        msgType: params.msgType,
        startTime: params.startTime,
        endTime: params.endTime,
        page: params.page,
        size: params.size,
        asc:params.asc
      },
      headers: {
        "authorization": authorization
      }
    },isloading)
  }



  


 

  





